<template>
    <div data-page data-layout-type="questionnaire" :data-layout-width="layout.LayoutWidth">
        <languageswitcher v-if="state.languages !== undefined && state.languages.length > 1" />

        <header
            data-header-questionnaire
            :data-position="layout.HeaderAlignmentPublicName"
            :data-min-height="state.languages !== undefined && state.languages.length > 1"
        >
            <div data-header-logo>
                <media
                    v-if="layout && layout.LogoImagePath"
                    data-logo
                    :url="state.layout.LogoImagePath"
                    alt="Layout Logo"
                    aria-hidden="true"
                    type="Image"
                    id="logo-image"
                />
            </div>
            <progressbar
                v-if="layout.ProgressBar.ShowProgressTopPublicName === 'WithPercentage' || layout.ProgressBar.ShowProgressTopPublicName === 'WithoutPercentage'"
            />    
            <div data-header-image>
                <media
                    v-if="layout && layout.HeaderImagePath"
                    :url="state.layout.HeaderImagePath"
                    alt="Layout header image"
                    aria-hidden="true"
                    type="Image"
                    id="header-image"
                />
            </div>
        </header>        
        <main data-main>
            <div
                v-if="layout.ShowEncouragementText === true"
                data-user-motivator
                aria-hidden="true"
                id="encouragement-bar"
            >
                <p>{{$store.getters.textResource(`rs_motivational_text`)}}</p>
            </div>
            <!-- Hidden live region to announce question title/description for screen readers -->
            <div
                ref="sr-live-region"
                aria-live="polite"
                aria-atomic="true"
                style="position: absolute; left: -10000px; width: 1px; height: 1px; overflow: hidden;"
            ></div>
            <form
                v-if="currentPage"
                id="form"
                :key="`form-${currentPage.id}`"
                v-on:submit.prevent
                :data-change-minHeight="currentPage.questions.length > 1"
                :data-no-top-border-radius="layout && layout.HeaderImagePath !== `` && layout.HeaderImagePath !== null ? `` : null"
            >
                <!-- <span data-hidden tabindex="0"></span> -->
                <!-- Used to focus with the keyboard after navigating. Is needed for usability and the router -->
                <template v-for="(question, index) in currentPage.questions">
                    <component
                        :is="currentQuestionType(question.type)"
                        :key="`question-${question.id}`"
                        :questionIndex="index"
                    />
                </template>
            </form>
            <div v-else data-question-placeholder></div>
            <div v-if="state.page.pageDescription" data-page-description>
                <p v-html="DOMPurify.sanitize(state.page.pageDescription)"></p>
            </div>
        </main>
    
        <footer>          
            <nav :data-centered-nav="layout.ProgressBar.ShowPercentageBottom === true ? `` : null">
                <navbutton
                    v-if="state.page && state.page.countdownGoSettings"
                    direction="right"
                    styling="secondary"
                    :text="(state.layout.NextButtonText === `` || state.layout.NextButtonText === null) ? $store.getters.textResource(`rs_next`) : state.layout.NextButtonText"
                    :disabled="state.page === undefined || state.global.showLoader || state.global.disableNavButtons"
                    :id="`next-nav`"
                    :countdownInSeconds="state.page.countdownGoSettings.countdownSeconds"
                    :countdownType="state.page.countdownGoSettings.displayValue"
                />
                <progressbarfooter v-if="layout.ProgressBar.ShowPercentageBottom === true" />
                <navbutton
                    v-if="state.page.previousButtonState !== `Hide`"
                    direction="left"
                    styling="tertiary"
                    :text="(state.layout.BackButtonText === `` || state.layout.BackButtonText === null) ? $store.getters.textResource(`rs_back`) : state.layout.BackButtonText"
                    :disabled="prevButtonShouldBeDisabled || state.global.showLoader || state.global.disableNavButtons"
                    :id="`back-nav`"
                />
            </nav>
            <div v-if="layout.RemovePoweredBy !== true" data-crowdtech-logo>
            <a :href="state.surveyInfo.culture === `nl-NL` ? `https://crowdtech.com/nl/over-crowdtech/pbc/` : `https://crowdtech.com/about-crowdtech/pbc/`" target="_blank">
                <media
                    :url="`${state.settings.assetPath}powered-by-crowdtech-logo-${constrastCheck}.svg`"
                    alt="Crowdtech logo"
                    type="Image"
                />
            </a>
            </div>
        </footer>
    </div>
</template>

<script>
import responsequestion from "@/questiontypes/ResponseQuestion.vue";
import ratingquestion from "@/questiontypes/RatingQuestion.vue";
import openquestion from "@/questiontypes/OpenQuestion.vue";
import tablequestion from "@/questiontypes/TableQuestion.vue";
import slidersemdifquestion from "@/questiontypes/SliderSemdifQuestion.vue";
import emptyquestion from "@/questiontypes/EmptyQuestion.vue";
import fieldsquestion from "@/questiontypes/FieldsQuestion.vue";
import selectboxquestion from "@/questiontypes/SelectBoxQuestion.vue";
import fileuploadquestion from "@/questiontypes/FileUploadQuestion.vue";
import hotspotquestion from "@/questiontypes/HotspotQuestion.vue";
import imagequestion from "@/questiontypes/ImageQuestion.vue";
import pointdistributionquestion from "@/questiontypes/PointDistributionQuestion.vue";
import rankingquestion from "@/questiontypes/RankingQuestion.vue";
import dragndropquestion from "@/questiontypes/DragAndDropQuestion.vue";
import locationquestion from "@/questiontypes/LocationQuestion.vue";
import kvkquestion from "@/questiontypes/KVKQuestion.vue";
import swipequestion from "@/questiontypes/SwipeQuestion.vue";
import progressbar from "@/components/Progressbar.vue";
import progressbarfooter from "@/components/ProgressbarFooter.vue";
import languageswitcher from "@/components/LanguageSwitcher.vue";
import navbutton from "@/components/Navbutton.vue";
import media from "@/components/Media.vue";
import Vue from "vue";
import VueSanitize from "vue-sanitize";
import store from "@/store/store";
import methods from "@/global/methods.js";

Vue.use(VueSanitize, store.state.global.allowedHtml);

export default {
    name: `questionnaire-view`,
    inject: ['DOMPurify'],
    components: {
        navbutton,
        responsequestion,
        progressbar,
        progressbarfooter,
        openquestion,
        tablequestion,
        slidersemdifquestion,
        fieldsquestion,
        selectboxquestion,
        imagequestion,
        media,
        ratingquestion,
        emptyquestion,
        hotspotquestion,
        languageswitcher,
        fileuploadquestion,
        pointdistributionquestion,
        rankingquestion,
        kvkquestion,
        dragndropquestion,
        swipequestion,
        locationquestion
    },
    computed: {
        state: function () {
            return this.$store.state;
        },
        currentPage: function () {
            return this.state.page;
        },
        prevButtonShouldBeDisabled() {
            // Preview should show all the colors of the buttons
            if (this.state.global.isPreview) return false;

            // If the page hasnt fully loaded or navigating back isn't alowed, disable the button
            return this.state.page === undefined || this.state.page.previousButtonState === `Disabled`;
        },
        layout: function () {
            return this.state.layout;
        },
        constrastCheck: function () {
            return methods.hexToRgb(this.layout.BackgroundColor);
        },
    },
    methods: {
        currentQuestionType: function (questionType) {
            switch (questionType) {
                case `Single`:
                case `Multi`:
                    return `responsequestion`;
                case `TableSingle`:
                case `TableMulti`:
                case `TableMixed`:
                    return `tablequestion`;
                case `Open`:
                    return `openquestion`;
                case `Slider`:
                case `SemanticDifferential`:
                    return `slidersemdifquestion`;
                case `Rating`:
                    return `ratingquestion`;
                case `EmptyQuestion`:
                    return `ratingquestion`;
                case `Fields`:
                    return `fieldsquestion`;
                case `Commerce`:
                    return `kvkquestion`;
                case `SelectBox`:
                    return `selectboxquestion`;
                case `Empty`:
                    return `emptyquestion`;
                case `TagIt`:
                    return `hotspotquestion`;
                case `PointDistribution`:
                    return `pointdistributionquestion`;
                case `ImageSingle`:
                case `ImageMulti`:
                    return `imagequestion`;
                case `Ranking`:
                    return `rankingquestion`;
                case `FileUpload`:
                    return `fileuploadquestion`;
                case `DragAndDrop`:
                    return `dragndropquestion`;
                case `Swipe`:
                    return `swipequestion`;
                case `Location`:
                    return `locationquestion`;
                default:
                    return ``;
            }
        },
    },
    created() {
        this.$store.commit(`changeGlobal`, {
            variableName: `showLoader`,
            newValue: false,
        });
    },
    mounted() {
        // Announce question title/description for the screenreader
        if (this.currentPage.questions.length > 0) {
            const firstQuestion = this.currentPage.questions[0];
            let announcement = firstQuestion.text;
            
            if (firstQuestion.descriptionAbove) announcement += firstQuestion.descriptionAbove;
            
            this.$refs['sr-live-region'].textContent = announcement;
        }
    },
};
</script>

<style scoped>
@import "./../styles/variables.css";

nav {
    display: flex;
    justify-content: center;
    flex-direction: row-reverse;
    width: 100%;
    button {
        margin: 10px;
    }
}

header[data-min-height] {
    min-height: 90px;
    display: flex;
    justify-content: center;
    padding-top: 38px;
}

[data-layout-type="questionnaire"]:has([data-header-logo]) [progressbar] {
    height: 50px;
}

[data-question-placeholder] {
    width: 100%;
    height: 400px;
    background: #f8f8f8;
    border-radius: 5px;
}

[data-page] {
    padding: 0 20px;
}
[data-page-description] {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 0px 35px 0 35px;
    p {
        font-size: calc(var(--DescriptionStyling-font-size) * 1px);
        font-family: var(--DescriptionStyling-font-family-public-name);
        color: var(--DescriptionStyling-color);
        width: 100%;
    }
}

[data-change-minHeight="true"] [question] {
    min-height: auto;
}

form {
    width: 100%;
    background: white;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;
    border-bottom-left-radius: 32px;
    border-bottom-right-radius: 32px;
}

[data-no-top-border-radius] {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

[progressbar] + [data-user-motivator] {
    position: absolute;
    width: calc(100% - 60px);
    height: 19px;
    border-radius: 5px;
    left: 35px;
    top: 92px;
}

[data-hidden] {
    width: 0;
    height: 0;
}

[data-user-motivator] {
    background: var(--encouragement-color);
    display: flex;
    width: 100%;
    height: 25px;
    border-radius: 0;
    justify-content: center;
    align-items: center;
    z-index: 1;
    
    p {
        color: #fff;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        margin: 0;
        position: relative;
    }
}

[data-centered-nav] {
    align-items: center;
}

@media only screen and (max-width: 550px) {
    body [data-page] {
        padding: 0 10px;
    }

    body [question] header {
        padding: 5px 15px 5px 15px;
    }

    footer {
        padding: 20px 0;
    }
}
</style>